import Request from '../helpers/request'
import RequestV2 from '../helpers/request-v2'
import Endpoints from '../config/endpoints'
import _ from "lodash"
import qs from 'qs'

export default class PersonRequests {

    static search(filter) {
        return RequestV2.getInstance()
            .createGetRequest(Endpoints.person.search, filter)
            .then(result => _.get(result, 'person[0]', null))
    }


    static save(personDTO, requestV2 = false) {

        if (requestV2)
            return RequestV2.getInstance().createPostRequest(Endpoints.person.save, personDTO)

        return Request.getInstance().createPostRequest(Endpoints.person.save, personDTO)
    }


    static recoverPassword(login) {
        return RequestV2.getInstance().createGetRequest(Endpoints.person.recoverPassword, {login})
    }


    static addContact(contactFormDTO) {
        const data = qs.stringify(contactFormDTO)

        return RequestV2.getInstance()
            .createPostRequest(Endpoints.person.addContact, data, {"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"})
    }


    static getInvoiceAccounts(prsCode) {

        return RequestV2
            .getInstance()
            .createGetRequest(
                Endpoints.invoiceAccount.search,
                {
                    personCodeRespOrPayerOrGuest: prsCode,
                    considerCancelled: false,
                    personCodeSaleType: 'GUEST',
                    orderByStatment: 's.saleDate DESC'
                }
            )
            .then(res => !!res ? res.invoiceaccount : null)

    }
}


// WEBPACK FOOTER //
// ./src/requests/person-requests.js